import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reduxForm } from "redux-form";
import { hydratePickups } from "containers/Pickups/actions";
import * as formActions from "./pickup-form.actions";
import PickupFormComponent from "./pickup-form.component";

const mapStateToProps = (state, ownProps) => {
  const isGuest = !state.auth.logged;

  const publicFormValues = state.donorWizard.formValues;

  let isFromPublicForm = false;
  let hasPublicFormBeenFilled = false;
  let foundPickupLocation = false;
  if (state.auth.logged) {
    // we know that the user came fom the public form
    // if the isFromPublicForm in location state is true
    isFromPublicForm =
      ownProps.location.state && ownProps.location.state.isFromPublicForm;
    hasPublicFormBeenFilled = Boolean(publicFormValues.address);
    // checking to see if there is an existing location for the address selected in the public form
    foundPickupLocation = state.locations.locations.find((location) => {
      return (
        publicFormValues.mapAddress === location.mapAddress ||
        (location.address === publicFormValues.address &&
          location.state === publicFormValues.state &&
          location.city === publicFormValues.city)
      );
    });
  }

  const getInitialStep = () => {
    // if the user if coming from the public form and they have filled out the address
    // send them to step 5, otherwise return the normal step
    if (isFromPublicForm && hasPublicFormBeenFilled) {
      return 5;
    } else {
      return publicFormValues.step;
    }
  };
  return {
    notes: state.donorWizard.formValues.notes,
    pickupBlocks: state.donorWizard.pickupBlocks,
    dropOffLocations: state.donorWizard.dropOffLocations,
    publicPickupForm: {
      ...publicFormValues,
      location: foundPickupLocation || publicFormValues.location,
      // since the initial step can vary depending on where the user is comngin form, we need to create this step dynamically
      initialStep: getInitialStep(),
    },
    user: isGuest ? publicFormValues.user : state.user,
    locations: state.locations,
    isFromPublicForm,
    isGuest,
    donationGuidelines:
      state.settings.globalSettings?.find(
        (setting) => setting.label === "donation-guidelines"
      )?.value || "",
    infoPage:
      state.settings.globalSettings?.find(
        (setting) => setting.label === "info-page"
      )?.value || "",
    settingsLoaded: state.settings.globalSettings.complete,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  formComplete: (pickup) => {
    dispatch(hydratePickups());
    // dispatch()
    dispatch(formActions.resetForm());
    dispatch({ type: "SEARCH_PICKUP_BLOCKS_RESET" });
    dispatch({ type: "DONOR_LOCATIONS_RESET" });
    ownProps.history.push(`/pickups/${pickup.id}`, "newPickup");
  },
  enterInitialFlow: () => dispatch(formActions.enterInitialFlow()),

  ...bindActionCreators(formActions, dispatch),
});

let ReduxPickupFormComponent = reduxForm({ form: "publicPickupForm" })(
  PickupFormComponent
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReduxPickupFormComponent);
